import React, { useRef, useEffect } from 'react';
import UseFormValidation from '@hooks/useFormValidation';
import { useLocation } from '@reach/router';

const NetlifyForm = ({ formFields, heading }) => {
  const location = useLocation();
  const formRef = useRef(null);
  const { handleSubmit, handleChange, success, formError } = UseFormValidation(
    {},
  );
  const convertToKebabCase = (string) => {
    return string.replace(/\s+/g, '-').toLowerCase();
  };
  const formName = convertToKebabCase(heading);

  useEffect(() => {
    if (success) {
      const yOffset = -300;
      const element = formRef.current;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }, [success, formRef]);

  const successMessage =
    location.pathname === '/gimc-partnership' ||
    heading === '2025 Tairāwhiti Holiday Programme'
      ? "Thank you for your submission – your child is now registered for the Music Education Tairāwhiti Holiday Programme. We'll be in touch with final details after registrations close on 20 June."
      : 'Thank you for your application, we will be in touch.';

  return (
    <form
      ref={formRef}
      name={formName}
      data-netlify='true'
      data-netlify-honeypot='bot-field'
      subject={`Website Enquiry - ${heading}`}
      onSubmit={handleSubmit}
      className=' mx-auto flex w-full'>
      <input type='hidden' name='form-name' value={formName} />
      <p hidden>
        <label>
          <input name='bot-field' onChange={handleChange} className='' />
        </label>
      </p>

      {success ? (
        <section className='flex lg:justify-center mx-auto w-full items-center '>
          <div className='richH3 text-teal'>{successMessage}</div>
        </section>
      ) : (
        <article className='w-full'>
          {formFields?.map(({ required, inputType, label, selectOptions }) => {
            const fieldName = convertToKebabCase(label);

            switch (inputType) {
              case 'select':
                return (
                  <div className='flex flex-col gap-5'>
                    <select
                      as='select'
                      required={required || false}
                      placeholder={label}
                      name={fieldName}
                      onChange={handleChange}
                      className='styledInput pl-0 pr-5'>
                      <option value='' checked>
                        {label}
                      </option>
                      {selectOptions.map((item) => {
                        return (
                          <>
                            <option required value={item.value}>
                              {item.name}
                            </option>
                          </>
                        );
                      })}
                    </select>
                  </div>
                );

              case 'textArea':
                return (
                  <div className=''>
                    <textarea
                      as='textArea'
                      rows='7'
                      required={required || false}
                      placeholder={label}
                      name={fieldName}
                      onChange={handleChange}
                      className='styledInput px-0'
                    />
                  </div>
                );
              default:
                return (
                  <div className=''>
                    <input
                      type={inputType || 'text'}
                      required={required || false}
                      name={fieldName}
                      placeholder={label}
                      onChange={handleChange}
                      className='styledInput px-0'
                    />
                  </div>
                );
            }
          })}
          {formError && <span>{formError}</span>}
          <div className='flex mx-auto justify-center mt-10'>
            <button
              type='submit'
              className='btn-standard bg-teal bg-opacity-10 px-7 py-2.5 text-teal blockH8 rounded-full font-bold'>
              Submit
            </button>
          </div>
        </article>
      )}
    </form>
  );
};

export default NetlifyForm;
